<template>
  <div
    class="flex flex-col items-center justify-center gap-4 p-4"
    :data-testid="testId"
  >
    <p v-if="message" class="text-center font-semibold text-lg">
      {{ message }}
    </p>
    <p v-else class="text-center font-semibold text-lg">{{ defaultMessage }}</p>

    <button
      :class="buttonClasses"
      aria-label="Reload Page"
      data-testid="reload-button"
      :disabled="loading"
      @click="handleReload"
    >
      <span v-if="!loading">Reload Page</span>
      <span v-else>Loading...</span>
    </button>

    <div class="w-full max-w-md mt-4">
      <button
        class="w-full text-left font-semibold text-teal-700 hover:underline"
        @click="toggleJsonView"
      >
        {{ isJsonExpanded ? "Hide Details" : "Show Details" }}
      </button>
      <pre
        v-if="isJsonExpanded"
        class="bg-gray-100 p-4 rounded text-sm overflow-auto"
      >
        {{ formattedJson }}
      </pre>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from "vue";

const props = defineProps({
  message: {
    type: String,
    default: null,
  },
  defaultMessage: {
    type: String,
    default: "Sorry, we couldn't load the student's details at this time.",
  },
  rawError: {
    type: Object,
    default: null,
  },
  testId: {
    type: String,
    default: "error-message",
  },
});

const loading = ref(false);
const isJsonExpanded = ref(false);

const buttonClasses = computed(() => {
  const baseClasses =
    "bg-teal-900 text-white font-semibold p-4 w-full md:w-auto text-center rounded hover:bg-teal-700 transition ease-in-out duration-200";
  return loading.value
    ? `${baseClasses} opacity-50 cursor-not-allowed`
    : baseClasses;
});

const formattedJson = computed(() =>
  props.rawError ? JSON.stringify(props.rawError, null, 2) : "{}"
);

const handleReload = () => {
  loading.value = true;
  try {
    location.reload();
  } catch (error) {
    console.error("Failed to reload the page:", error);
  } finally {
    loading.value = false;
  }
};

const toggleJsonView = () => {
  isJsonExpanded.value = !isJsonExpanded.value;
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

pre {
  max-height: 300px;
  overflow-y: auto;
  word-wrap: break-word;
}
</style>
